// extracted by mini-css-extract-plugin
export default {"drawer":"SHied","drawerHeader":"ECXvZ"};